import { removeItem, setItem } from 'owa-local-storage';
import { ThemeConstants } from 'owa-theme-shared';

// The image key is stored in local storage to initiate the request earlier during boot
// enhancing the speed of future app launches
export function addImageUrlToLocalStorage(imageUrl: string): void {
    setItem(self, ThemeConstants.LOCAL_IMAGE_STORAGE_KEY, imageUrl);
}

// This is to ensure that the image key is not stored in local storage for non-full bleed themes
// Full bleed themes are the ones that have the bleedThrough capability enabled
// which are the modern and copilot themes
export function removeImageUrlFromLocalStorage(): void {
    removeItem(self, ThemeConstants.LOCAL_IMAGE_STORAGE_KEY);
}
